// Polyfills e core
import '../utils/polyfill-ios-13'
import * as ActiveStorage from '@rails/activestorage'
import { Turbo } from '@hotwired/turbo-rails'

// Alpine.js
import 'alpine-turbo-drive-adapter'
import Alpine from 'alpinejs'
import stories from '../components/alpine/stories.js'

// Controllers
import '../controllers'
import '../controllers/base'
import '../controllers/merchant'
import '../components'

// Inicialização
ActiveStorage.start()
window.Turbo = Turbo

Alpine.data('stories', stories)
window.Alpine = Alpine
Alpine.start()

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js', { scope: './' })
    .catch(error => console.error('Error registering service worker:', error))
}

document.addEventListener('turbo:before-frame-render', (event) => {
  if (document.startViewTransition) {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => originalRender(currentElement, newElement))
    }
  }
})

// HMR support
if (import.meta.hot) {
  import.meta.hot.accept()
}
